import { render, staticRenderFns } from "./DebugUI.vue?vue&type=template&id=4b1735cd&"
import script from "./DebugUI.vue?vue&type=script&lang=ts&"
export * from "./DebugUI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports